<div class="W">
    <sfcu-message [type]="MessageType.WARNING">
        <div class="alert">
            <img ngSrc="https://static.s-sfr.fr/assets/pictos/outil_40_rouge.svg" width="64" height="64"/>
        </div>
        <h3>
            Une erreur est survenue
        </h3>
        <p>{{ error }}</p>
    </sfcu-message>
</div>


<div class="actions c">
    <sfc-btn-retour [class]="'btn4'" text="Retour à l'accueil"></sfc-btn-retour>
</div>
